import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { CircleHelp, ChevronRight } from "lucide-react";

const DEFAULT_WA = "22988791498";

/** Único cartão de suporte fixo na lateral esquerda; abre o WhatsApp configurado. */
export default function SupportFab() {
  const { user } = useAuth();
  const [whatsapp, setWhatsapp] = useState(DEFAULT_WA);

  useEffect(() => {
    if (!user) return;
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/settings");
        if (active && data?.whatsapp_company) setWhatsapp(data.whatsapp_company);
      } catch {
        // Usa o número padrão se as configurações não estiverem disponíveis.
      }
    })();
    return () => { active = false; };
  }, [user]);

  const openChat = () => {
    const cleaned = String(whatsapp || "").replace(/\D/g, "");
    if (!cleaned) return;
    const nome = user?.name || user?.email || "";
    const empresa = user?.business_name ? ` da ${user.business_name}` : "";
    const saudacao = nome ? `Olá, aqui é ${nome}${empresa}.` : "Olá,";
    const msg = `${saudacao} Preciso de ajuda com o painel MS Soluções Financeiras.`;
    const international = cleaned.startsWith("55") ? cleaned : `55${cleaned}`;
    window.open(`https://wa.me/${international}?text=${encodeURIComponent(msg)}`, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {/* Atalho de suporte no canto inferior esquerdo */}
      <button
        type="button"
        onClick={openChat}
        className="support-sidebar-card flex w-full min-w-0 items-center gap-2.5 rounded-xl px-2.5 py-3 text-left text-white transition-all duration-200"
        aria-label="Suporte: abrir WhatsApp"
        data-testid="support-left"
      >
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-cyan-400/45 bg-blue-500/15 text-cyan-300 shadow-[0_0_12px_rgba(0,145,255,0.18)]">
          <CircleHelp className="h-5 w-5" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-xs font-bold leading-4">Suporte</span>
          <span className="block text-[10px] leading-4 text-slate-400">Precisa de ajuda?</span>
        </span>
        <ChevronRight className="h-4 w-4 shrink-0 text-cyan-300" />
      </button>


    </>
  );
}
